import { h, Component } from "preact";
import PropTypes from "prop-types";

import styles from "./HappinessOverviewPage.scss";

import { HappinessOverview } from "../components/happinessOverview";
import { HappinessMenu, menuOptions } from "../../menu";
import { LOCALSTORAGE_USER_ID, ON_MOBILE_DEVICE } from "../../../config";
import { connect } from "preact-redux";
import { getAllHappinessForUser, getUserInformation } from "../actions";
import userShape from "../../../support/userShape";
import { Header, Image } from "semantic-ui-react";
import GoogleSheetsExport from "../components/google-sheets/GoogleSheetsExport";

export class HappinessOverviewPage extends Component {
  constructor(props) {
    super(props);
    this.props.getUserInformation(
      this.props.userId || localStorage.getItem(LOCALSTORAGE_USER_ID)
    );
    this.props.getAllHappinessForUser(
      this.props.userId || localStorage.getItem(LOCALSTORAGE_USER_ID)
    );
  }

  render() {
    const { happinessData, currentOverviewUser } = this.props;
    const userComponents = [
      <Header key="header" style={{ margin: "1rem" }}>
        <Image
          className={styles.headerImage}
          src={currentOverviewUser.picture_url}
          rounded
          size="tiny"
        />
        {currentOverviewUser.first_name} {currentOverviewUser.last_name}
      </Header>,
      !ON_MOBILE_DEVICE() && (
        <GoogleSheetsExport
          key="export"
          currentOverviewUser={currentOverviewUser}
          happinessData={happinessData}
        />
      ),
    ];
    const menu = (
      <HappinessMenu
        key="menu"
        headerText={"Overview"}
        componentsToRender={userComponents}
        selectedPage={menuOptions.HAPPINESS_OVERVIEW}
      />
    );
    const mainComponents = [
      ON_MOBILE_DEVICE() && userComponents,
      <HappinessOverview
        key="overview"
        currentOverviewUser={currentOverviewUser}
        happinessData={happinessData}
      />,
    ];
    ON_MOBILE_DEVICE()
      ? mainComponents.push(menu)
      : mainComponents.unshift(menu);
    return <div className={styles.container}>{mainComponents}</div>;
  }
}

HappinessOverviewPage.PropTypes = {
  userId: PropTypes.number.isRequired,
  currentOverviewUser: PropTypes.shape(userShape).isRequired,
  getAllHappinessForUser: PropTypes.func.isRequired,
  getUserInformation: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  happinessData: state.diary.happinessData,
  currentOverviewUser: state.diary.currentOverviewUser,
});

const mapDispatchToProps = {
  getAllHappinessForUser,
  getUserInformation,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HappinessOverviewPage);



// WEBPACK FOOTER //
// ./src/modules/diary/pages/HappinessOverviewPage.js